import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import env from "env";
export interface LoginRequest {
  username?: string;
  password?: string;
  client_id?: string;
  code?: string;
  code_verifier?: string;
  redirect_uri?: string;
  grant_type?: string;
  scope?: string;
}

export interface AuthResponse {
  access_token: string;
  expires_in: number;
  id_token: string;
  refresh_token: string;
  scope: string;
  token_type: string;
}

export const authApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: env.api.baseUrl.tokenBaseUrl,
  }),
  endpoints: (builder) => ({
    login: builder.mutation<AuthResponse, LoginRequest>({
      query: (credentials) => {
        const token = btoa(`${env.api.clientId}:${env.api.clientSecret}`);

        return {
          url: "oauth2/token",
          headers:
            credentials.grant_type === "authorization_code"
              ? {
                  "Content-Type": "application/x-www-form-urlencoded",
                }
              : {
                  Authorization: `Basic ${token}`,
                  "Content-Type": "application/x-www-form-urlencoded",
                },
          method: "POST",
          body: (function () {
            const formBody = [
              { key: "username", value: credentials.username },
              { key: "password", value: credentials.password },
              { key: "grant_type", value: credentials.grant_type },
              { key: "scope", value: credentials.scope },
              { key: "client_id", value: credentials.client_id },
              { key: "code", value: credentials.code },
              { key: "code_verifier", value: credentials.code_verifier },
              { key: "redirect_uri", value: credentials.redirect_uri },
            ]
              .filter((n) => n.value)
              .map(
                (n) =>
                  encodeURIComponent(n.key) +
                  "=" +
                  encodeURIComponent(n.value || "")
              )
              .join("&");
            return formBody;
          })(),
        };
      },
      extraOptions: {
        retry: false,
      },
    }),
    logout: builder.mutation<void, string>({
      query: (refreshToken) => {
        return {
          url: "oauth2/revoke",
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: (function () {
            const formBody = [
              { key: "token", value: refreshToken },
              { key: "token_type_hint", value: "access_token" },
              { key: "client_id", value: env.app.authCodeAppId },
            ]
              .map(
                (n) =>
                  encodeURIComponent(n.key) + "=" + encodeURIComponent(n.value)
              )
              .join("&");
            return formBody;
          })(),
        };
      },
    }),
  }),
});

export const { useLoginMutation, useLogoutMutation } = authApi;
